import { render, staticRenderFns } from "./pgoodsDetail.vue?vue&type=template&id=1cce91ee&scoped=true"
import script from "./pgoodsDetail.vue?vue&type=script&lang=js"
export * from "./pgoodsDetail.vue?vue&type=script&lang=js"
import style0 from "./pgoodsDetail.vue?vue&type=style&index=0&id=1cce91ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cce91ee",
  null
  
)

export default component.exports